import {
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from 'app/core/auth/auth.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogRef } from '@angular/material/dialog';
import { GuestAuthComponent } from '../../guest-auth/guest-auth-form.component';

export type CloseGuestModalResponse = {
    success: boolean | undefined;
}

@Component({
    selector: 'modal-guest-auth',
    templateUrl: './modal-guest-auth.component.html',
    styleUrls: ['./modal-guest-auth.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    imports: [
        MatDividerModule,
        MatIconModule,
        GuestAuthComponent
    ],
})
export class ModalGuestAuthComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _dialogRef: MatDialogRef<ModalGuestAuthComponent>
    ) {
    }

    /**
     * On init
     */
    ngOnInit(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    signInSuccess() {
        this.closeModal({
            success: true
        });
    }


    handleError() {
        this._authService.signOut();
        this._dialogRef.close();
    }

    closeModal(data?: CloseGuestModalResponse) {
        this._authService.verifySessionToken().subscribe();
        this._dialogRef.close(data);
    }
}
